import { render, staticRenderFns } from "./AffiliateNewsHistory.vue?vue&type=template&id=0c2ded3f&scoped=true&"
import script from "./AffiliateNewsHistory.vue?vue&type=script&lang=js&"
export * from "./AffiliateNewsHistory.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateNewsHistory.vue?vue&type=style&index=0&id=0c2ded3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2ded3f",
  null
  
)

export default component.exports